<aside class="login-shell__hero" aria-hidden="true">

  <!-- Wavy gradient contour background: dark -> brand red -->
  <svg class="login-shell__hero-waves"
       viewBox="0 0 800 800"
       preserveAspectRatio="xMidYMid slice"
       xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="loginHeroWaveSoft" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#4A0D0E" stop-opacity="0.6" />
        <stop offset="100%" stop-color="#C8273D" stop-opacity="0.35" />
      </linearGradient>
      <linearGradient id="loginHeroWaveStrong" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#4A0D0E" stop-opacity="0.9" />
        <stop offset="100%" stop-color="#C8273D" stop-opacity="0.6" />
      </linearGradient>
    </defs>
    <g fill="none" stroke="url(#loginHeroWaveSoft)" stroke-width="1.4" stroke-linecap="round">
      <path d="M-100,160 Q200,60 400,200 T900,160" />
      <path d="M-100,240 Q200,140 400,280 T900,240" />
      <path d="M-100,320 Q200,220 400,360 T900,320" />
      <path d="M-100,400 Q200,300 400,440 T900,400" />
      <path d="M-100,480 Q200,380 400,520 T900,480" />
      <path d="M-100,560 Q200,460 400,600 T900,560" />
      <path d="M-100,640 Q200,540 400,680 T900,640" />
    </g>
    <g fill="none" stroke="url(#loginHeroWaveStrong)" stroke-width="2" stroke-linecap="round">
      <path d="M-100,200 Q260,80 500,260 T1000,220" />
      <path d="M-100,460 Q260,340 500,520 T1000,480" />
    </g>
  </svg>

  <!-- Floating 4H bubbles with motion and trailing glow -->
  <div class="login-shell__bubble login-shell__bubble--head"
       (mouseenter)="hoveredBubble = 'head'" (mouseleave)="hoveredBubble = null">
    <img src="/assets/icons/head.svg" class="login-shell__bubble-icon" alt="" />
  </div>
  <div class="login-shell__bubble login-shell__bubble--heart"
       (mouseenter)="hoveredBubble = 'heart'" (mouseleave)="hoveredBubble = null">
    <img src="/assets/icons/heart.svg" class="login-shell__bubble-icon" alt="" />
  </div>
  <div class="login-shell__bubble login-shell__bubble--hands"
       (mouseenter)="hoveredBubble = 'hands'" (mouseleave)="hoveredBubble = null">
    <img src="/assets/icons/hands.svg" class="login-shell__bubble-icon" alt="" />
  </div>
  <div class="login-shell__bubble login-shell__bubble--results"
       (mouseenter)="hoveredBubble = 'results'" (mouseleave)="hoveredBubble = null"
       (click)="onResultsClick()">
    <img src="/assets/icons/results.svg" class="login-shell__bubble-icon" alt="" />
  </div>

  <!-- Center hover caption -->
  <div class="login-shell__hero-caption-wrap" *ngIf="hoveredBubble" @captionFade>
    <p class="login-shell__hero-caption">{{ bubbleTexts[hoveredBubble] }}</p>
  </div>

</aside>
